var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m453.632 88.355c0-8.284-6.716-15-15-15h-258.557l-48.561-48.561c-2.813-2.813-6.628-4.394-10.606-4.394h-105.908c-8.284 0-15 6.716-15 15v133.862h453.632z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m402.581 242.76c18.01 0 35.234 3.433 51.051 9.678v-53.175h-453.632v206.815c0 8.284 6.716 15 15 15h253.691c-3.595-12.352-5.529-25.404-5.529-38.9-.001-76.875 62.543-139.418 139.419-139.418z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m402.581 272.76c-60.334 0-109.42 49.085-109.42 109.419s49.086 109.42 109.42 109.42 109.419-49.086 109.419-109.42-49.085-109.419-109.419-109.419zm33.618 124.419h-18.618v18.619c0 8.284-6.716 15-15 15s-15-6.716-15-15v-18.619h-18.619c-8.284 0-15-6.716-15-15s6.716-15 15-15h18.619v-18.619c0-8.284 6.716-15 15-15s15 6.716 15 15v18.619h18.618c8.284 0 15 6.716 15 15s-6.716 15-15 15z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.f491d09061bd8802a0889b9c75fbb4ed.svg";
export { ForwardRef as ReactComponent };